const map = {
	"./a11ycat/slice.js": "./src/modules/a11ycat/slice.js",
	"./api/slice.js": "./src/modules/api/slice.js",
	"./app/slice.js": "./src/modules/app/slice.js",
	"./applications/slice.js": "./src/modules/applications/slice.js",
	"./authentication/slice.js": "./src/modules/authentication/slice.js",
	"./toast/slice.js": "./src/modules/toast/slice.js",
	"./user/slice.js": "./src/modules/user/slice.js"
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/modules sync recursive \\.\\/\\w+\\/slice(.js%7C\\/index.js)";